declare global {
  interface Window {
    Cypress?: unknown;
    mockOnPremise?: boolean;
  }
}

export const enum Environment {
  DEVELOPMENT = 'development',
  TESTING = 'test',
  PRODUCTION = 'production',
}

export const isDevelopment = (
  nodeEnv: string | undefined = process.env.NODE_ENV
) => !nodeEnv || nodeEnv === Environment.DEVELOPMENT;

export const isTesting = (nodeEnv: string | undefined = process.env.NODE_ENV) =>
  nodeEnv === Environment.TESTING;

export const isProduction = (
  nodeEnv: string | undefined = process.env.NODE_ENV
) => nodeEnv === Environment.PRODUCTION;

export const isSnapshot = (
  snapshot: string | undefined = process.env.SNAPSHOT
) => snapshot === 'true';

export const isDevelopOrSnapshot = (
  nodeEnv: string | undefined = process.env.NODE_ENV,
  snapshot: string | undefined = process.env.SNAPSHOT
) => isDevelopment(nodeEnv) || isSnapshot(snapshot);

export const isDevelopOrTesting = (
  nodeEnv: string | undefined = process.env.NODE_ENV
) => isDevelopment(nodeEnv) || isTesting(nodeEnv);

export const isCypress = () => window.Cypress !== undefined;
